import { defineMessages } from 'react-intl'

export default defineMessages({
  oops: {
    id: 'pages.Error.oops',
    defaultMessage: 'Oops',
  },
  homepage: {
    id: 'pages.Error.homepage',
    defaultMessage: 'Back to Home page',
  },
})
